<template>
	<div class="item">
		<span class="label"
			>{{ field.dynamicFieldName }}<span class="required ml6" v-if="field.config == 1">*</span></span
		>
		<input
			class="common-input"
			v-model="internalValue"
			type="text"
			:placeholder="field.dynamicFieldDescribed || $t('enterprise.field.input')"
			@input="updateParent"
		/>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
	field: {
		type: Object,
		required: true
	},
	index: {
		type: Number,
		required: true
	}
});

const emit = defineEmits(['update']);

const internalValue = ref('');

watch(
	() => props.field.dynamicFieldValue,
	newVal => {
		internalValue.value = newVal || '';
	},
	{ immediate: true }
);

const updateParent = () => {
	emit('update', internalValue.value);
};
</script>

<style lang="less" scoped>
.item {
	padding: 0.14rem 0;
	display: flex;
	align-items: center;
	justify-items: center;
	font-size: 0.15rem;
	color: #333;

	.label {
		flex-shrink: 0;
		width: 0.83rem;
	}

	.common-input {
		flex: 1;
		margin-left: 0.06rem;
		border: none;
		text-align: right;
		height: 0.21rem;
		line-height: 0.21rem;
	}

	.ml6 {
		margin-left: 0.06rem;
	}

	.required {
		color: #eb5149;
		font-size: 0.15rem;
		font-weight: 400;
		vertical-align: middle;
	}
}
</style>
